<template>
  <div>
    <titulo-modulo titulo="Holerites" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-row class="mt-0">
        <v-col cols="12" sm="6" md="3" lg="3" xl="2">
          <v-select
            v-model="mesSelecionado"
            :items="meses"
            label="Mês"
            item-text="descricao"
            item-value="mes"
            @change="getFilterHolerites"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="3" xl="2">
          <v-select
            v-model="anoSelecionado"
            :items="anos"
            label="Ano"
            @change="getFilterHolerites"
            required
          ></v-select>
        </v-col>
        <v-col>
          <v-btn
            color="warning"
            depressed
            rounded
            class="mt-3"
            @click="limparFiltros"
            >Limpar filtros</v-btn
          >
        </v-col>
      </v-row>
      <v-alert v-if="getFilterHolerites().length == 0" type="info" text>
        Nenhum holerite encontrado para este mês/ano
      </v-alert>
      <lista-holerites v-else :holerites="getFilterHolerites()" />
    </template>
  </div>
</template>

<script>
import axios from "axios";
import TituloModulo from "../../components/TituloModulo.vue";
import { getMeses } from "@/global";
import ListaHolerites from "./components/ListaHolerites.vue";

export default {
  components: { TituloModulo, ListaHolerites },
  data: () => ({
    carregando: false,
    meses: getMeses,
    anos: [],
    mesSelecionado: 0,
    anoSelecionado: 0,
    holerites: [],
  }),
  methods: {
    async getHolerites() {
      this.carregando = true;
      this.holerites = [];
      await axios
        .get(`/colaborador/holerites`)
        .then((res) => {
          if (res.data.success) {
            this.holerites = res.data.data;
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) =>
          this.$toasted.error(`Houve um erro ao carregar os holerites. ${e}`)
        );
      this.carregando = false;
    },
    getAnos() {
      this.anos = [];
      for (
        let ano = new Date().getFullYear();
        ano >= new Date().getFullYear() - 2;
        ano--
      ) {
        this.anos.push(ano);
      }
    },
    getFilterHolerites() {
      return this.holerites.filter(
        (hol) =>
          (hol.ano == this.anoSelecionado || this.anoSelecionado == 0) &&
          (hol.mes == this.mesSelecionado || this.mesSelecionado == 0)
      );
    },
    async limparFiltros() {
      this.anoSelecionado = 0;
      this.mesSelecionado = 0;
      await this.getHolerites();
    },
  },
  async mounted() {
    this.getAnos();
    await this.getHolerites();
  },
};
</script>
